export default {
    name: "BlogPost",
    props: {
        info: {
            type: Object,
            required: true,
        },
    },
}